import Service, { getCallApiFunction } from '../service'
// import denormalizer from './denormalizer'
// import normalizer from './normalizer'

// Interface
export interface IFetchPromotionListParams {
  skuList: ISelectedSku[]
}

interface ISelectedSku {
  quantity: number
  skuId: number
}

class fetchPromotionListApi extends Service {
  constructor(params: IFetchPromotionListParams) {
    super()
    this.name = 'FETCH_PROMOTION_TICKET_LIST'

    this.config = {
      url: `/v1/promotion/tickets`,
      method: 'POST',
      data: { ...params },
    }
  }
}

export const fetchPromotionList = (params: IFetchPromotionListParams) => getCallApiFunction(new fetchPromotionListApi(params))
